import './_mini-cart-recommendations.scss';
import component from './mini-cart-recommendations';

export default component;
